<template>
    <div>
        <navbar-header page-name="Сборка товара"/>
        <orders-collecting class="body"></orders-collecting>
    </div>
</template>

<script>
import NavbarHeader from '@/components/NavbarHeader'
import OrdersCollecting from '@/components/OrdersCollecting'
export default {
  name: 'OrdersCollectingLayout',
  data () {
    return {
    }
  },
  components: {
    OrdersCollecting,
    NavbarHeader
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .navbar-text {
        padding: 0 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/OrdersCollectingLayout.vue